// extracted by mini-css-extract-plugin
export default {"header":"EVipFranchiseDealerItems-header","item":"EVipFranchiseDealerItems-item"};